import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateWorkspaceScaleCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	levelsSerialized?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _levelsSerialized = isRef<string>(levelsSerialized) ? levelsSerialized : ref<string>((typeof levelsSerialized === 'function') ? levelsSerialized() : levelsSerialized)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		name: _name,
		description: _description,
		levelsSerialized: _levelsSerialized,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof levelsSerialized === 'function') { _levelsSerialized.value = levelsSerialized() }

			return new c.CreateWorkspaceScaleCommandV1(_workspaceId.value, _id.value, _name.value, _description.value, _levelsSerialized.value)
		})
	}

	return {
		...result,
		authorizedCreateWorkspaceScaleCommandV1: result.authorized,
		createWorkspaceScaleCommandV1: result.command,
		completedCreateWorkspaceScaleCommandV1: result.completed,
		errorCreateWorkspaceScaleCommandV1: result.error,
		invokeCreateWorkspaceScaleCommandV1: result.invoke,
		invokingCreateWorkspaceScaleCommandV1: result.invoking,
		succeedCreateWorkspaceScaleCommandV1: result.succeed,
		validationErrorsCreateWorkspaceScaleCommandV1: result.validationErrors,
		onSucceedCreateWorkspaceScaleCommandV1: result.onSucceed,
	}
}

export function useDeleteWorkspaceScaleCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteWorkspaceScaleCommandV1(_workspaceId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteWorkspaceScaleCommandV1: result.authorized,
		deleteWorkspaceScaleCommandV1: result.command,
		completedDeleteWorkspaceScaleCommandV1: result.completed,
		errorDeleteWorkspaceScaleCommandV1: result.error,
		invokeDeleteWorkspaceScaleCommandV1: result.invoke,
		invokingDeleteWorkspaceScaleCommandV1: result.invoking,
		succeedDeleteWorkspaceScaleCommandV1: result.succeed,
		validationErrorsDeleteWorkspaceScaleCommandV1: result.validationErrors,
		onSucceedDeleteWorkspaceScaleCommandV1: result.onSucceed,
	}
}

export function useUpdateWorkspaceScaleCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	levelsSerialized?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _levelsSerialized = isRef<string>(levelsSerialized) ? levelsSerialized : ref<string>((typeof levelsSerialized === 'function') ? levelsSerialized() : levelsSerialized)

	const result = {
		workspaceId: _workspaceId,
		id: _id,
		name: _name,
		description: _description,
		levelsSerialized: _levelsSerialized,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof levelsSerialized === 'function') { _levelsSerialized.value = levelsSerialized() }

			return new c.UpdateWorkspaceScaleCommandV1(_workspaceId.value, _id.value, _name.value, _description.value, _levelsSerialized.value)
		})
	}

	return {
		...result,
		authorizedUpdateWorkspaceScaleCommandV1: result.authorized,
		updateWorkspaceScaleCommandV1: result.command,
		completedUpdateWorkspaceScaleCommandV1: result.completed,
		errorUpdateWorkspaceScaleCommandV1: result.error,
		invokeUpdateWorkspaceScaleCommandV1: result.invoke,
		invokingUpdateWorkspaceScaleCommandV1: result.invoking,
		succeedUpdateWorkspaceScaleCommandV1: result.succeed,
		validationErrorsUpdateWorkspaceScaleCommandV1: result.validationErrors,
		onSucceedUpdateWorkspaceScaleCommandV1: result.onSucceed,
	}
}

